import React from 'react';

const locations = [
  {
    city: "NYC.",
    contact: "sms \\ 203.410.3034",
    phone: "+12034103034",
    email: "newyork@chrsma.co"
  },
  {
    city: "BOS.",
    contact: "sms \\ 617.229.6180",
    phone: "+16172296180",
    email: "boston@chrsma.co"
  },
  {
    city: "ROK.",
    contact: "010.2163.3525",
    phone: "+821021633525",
    email: "korea@chrsma.co"
  },
  {
    city: "BALI.",
    contact: "mms \\ +1 203.410.3034",
    phone: "+12034103034",
    email: "bali@chrsma.co"
  }
];

export const Footer = () => {
  return (
    <footer className="bg-c-dark pt-8 pb-12">
      {/* Animated gradient divider */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-14 md:mb-20">
        <div className="footer-gradient-line h-[2px] w-full"></div>
      </div>

      {/* Locations */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-10 md:mb-16">
        {/* Desktop: 4-col centered */}
        <div className="hidden md:grid md:grid-cols-4 gap-8">
          {locations.map((loc) => (
            <div key={loc.city} className="text-center">
              <h4 className="font-serif-italic text-3xl text-c-cream/80 mb-4">{loc.city}</h4>
              <a href={`tel:${loc.phone}`} className="block text-sm text-c-powder/60 hover:text-c-powder transition-colors mb-1">{loc.contact}</a>
              <a href={`mailto:${loc.email}`} className="block text-sm text-c-powder/60 hover:text-c-powder transition-colors">{loc.email}</a>
            </div>
          ))}
        </div>

        {/* Mobile: 2-col, left-aligned, tighter */}
        <div className="grid grid-cols-2 gap-8 md:hidden">
          {locations.map((loc) => (
            <div key={loc.city}>
              <h4 className="font-serif-italic text-xl text-c-cream/80 mb-2">{loc.city}</h4>
              <a href={`tel:${loc.phone}`} className="block text-xs text-c-powder/60 hover:text-c-powder transition-colors mb-0.5">{loc.contact}</a>
              <a href={`mailto:${loc.email}`} className="block text-xs text-c-powder/60 hover:text-c-powder transition-colors">{loc.email}</a>
            </div>
          ))}
        </div>
      </div>

      {/* Subtle divider */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 mb-10 md:mb-16">
        <div className="h-[1px] w-full bg-c-navy-light/30"></div>
      </div>

      {/* Bottom bar */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Desktop: side-by-side */}
        <div className="hidden md:flex md:flex-row justify-between items-end">
          <div>
            <h3 className="text-4xl font-light text-c-cream/80 mb-2">
              Inspire <span className="font-serif-italic text-gradient">Devotion.</span>
            </h3>
            <p className="text-sm text-c-powder/50">
              Earn loyalty through <span className="text-c-powder/70">clarity, consistency, and character.</span>
            </p>
          </div>
          <div className="text-right">
            <div className="font-wordmark text-c-cream text-xl mb-4">
              chRsMa<span className="text-c-powder/40 text-sm">.co</span>
            </div>
            <div className="flex gap-6 mb-3 justify-end">
              <a href="/privacy" className="text-[10px] font-light tracking-widest uppercase text-c-powder/40 hover:text-c-cream transition-colors">Privacy</a>
              <a href="/terms" className="text-[10px] font-light tracking-widest uppercase text-c-powder/40 hover:text-c-cream transition-colors">Terms</a>
            </div>
            <p className="text-[10px] font-light tracking-widest uppercase text-c-powder/40">
              &copy; Copyright {new Date().getFullYear()}. CHRSMA CO. All Rights Reserved.
            </p>
          </div>
        </div>

        {/* Mobile: stacked, centered */}
        <div className="md:hidden text-center">
          <h3 className="text-2xl font-light text-c-cream/80 mb-2">
            Inspire <span className="font-serif-italic text-gradient">Devotion.</span>
          </h3>
          <p className="text-xs text-c-powder/50 mb-8">
            Earn loyalty through <span className="text-c-powder/70">clarity, consistency, and character.</span>
          </p>
          <div className="font-wordmark text-c-cream text-lg mb-6">
            chRsMa<span className="text-c-powder/40 text-sm">.co</span>
          </div>
          <div className="flex gap-6 justify-center mb-4">
            <a href="/privacy" className="text-[10px] font-light tracking-widest uppercase text-c-powder/40 hover:text-c-cream transition-colors">Privacy</a>
            <a href="/terms" className="text-[10px] font-light tracking-widest uppercase text-c-powder/40 hover:text-c-cream transition-colors">Terms</a>
          </div>
          <p className="text-[10px] font-light tracking-widest uppercase text-c-powder/30">
            &copy; {new Date().getFullYear()} CHRSMA CO.
          </p>
        </div>
      </div>
    </footer>
  );
};
